import { IncomingEmailsTable } from "@/components/mailboxes";

/** Props Interface */
interface MailboxEmailsProps {
	mailboxId: string;
}

export function MailboxEmails({ mailboxId }: MailboxEmailsProps) {
	/** Render */
	return (
		<IncomingEmailsTable
			mailboxId={mailboxId}
			persistenceKey="mailbox-emails-table"
		/>
	);
}
